import React from "react";
import { Dropdown } from "react-bootstrap";
import Icon from "@mdi/react";
import { mdiDotsHorizontal } from "@mdi/js";
import formatDate from "app/containers/Templates/utils/formatDate";
import ContractBadges from "./ContractBadges";
import { getSetDefaultState } from "./templateHelpers";

const ContractCard = ({
  template,
  onOpen,
  onSetDefault,
  onDelete,
  onDuplicate,
}) => {
  const { disabled: setDefaultDisabled, title: setDefaultTitle } =
    getSetDefaultState(template);
  const deleteDisabled = template.is_system;

  const stop = (e) => e.stopPropagation();

  return (
    <div className="contract-card" onClick={onOpen}>
      <div className="contract-card-body">
        <div className="contract-card-name">{template.name}</div>
        <ContractBadges template={template} />
        <div className="contract-card-footer">
          <span className="contract-card-date">
            {formatDate(template.updated_at)}
          </span>
          <div className="contract-card-actions" onClick={stop}>
            <button
              type="button"
              className="contract-view-btn"
              onClick={onOpen}
            >
              View
            </button>
            <Dropdown align="end" onClick={stop}>
              <Dropdown.Toggle
                as="button"
                className="contract-icon-btn contract-three-dots"
                aria-label="More actions"
              >
                <Icon path={mdiDotsHorizontal} size={0.67} />
              </Dropdown.Toggle>
              <Dropdown.Menu className="contract-dropdown-menu">
                <Dropdown.Item
                  disabled={setDefaultDisabled}
                  onClick={onSetDefault}
                  title={setDefaultTitle}
                >
                  Set as Default
                </Dropdown.Item>
                <Dropdown.Item onClick={onDuplicate}>Duplicate</Dropdown.Item>
                <Dropdown.Item
                  disabled={deleteDisabled}
                  onClick={onDelete}
                  className={deleteDisabled ? "" : "contract-dropdown-danger"}
                >
                  Delete
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContractCard;
